import React, { useState } from 'react';
import Pagination from 'react-js-pagination';

const PaginatedFamilyMembersTable = ({ 
  familyMembers, 
  selectedFamilyMembers, 
  onFamilyMemberSelect, 
  isLoading, 
  filterMessage,
  itemsPerPage = 5 
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  // Calculate total items
  const totalItemsCount = familyMembers.length;
  
  // Get current page data
  const getCurrentPageItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return familyMembers.slice(startIndex, endIndex);
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className="table-responsive" style={{ overflowX: "hidden" }}>
        <table className="table">
          <thead>
            <tr>
              <th>Family Member</th>
              <th>CareWindow User</th>
              <th>Selected</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  <div
                    className="spinner-border spinner-border-sm text-primary mr-2"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                  Loading family members...
                </td>
              </tr>
            ) : familyMembers.length > 0 ? (
              getCurrentPageItems().map((member) => (
                <tr key={member.id}>
                  <td>
                    {member.profilePicture ? (
                      <img
                        className="user-photo"
                        src={`data:image/png;base64, ${member.profilePicture}`}
                        alt={member.name}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          marginRight: "10px",
                        }}
                      />
                    ) : (
                      <span
                        className="user-icon"
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          marginRight: "10px",
                          display: "inline-block",
                          textAlign: "center",
                          lineHeight: "30px",
                          backgroundColor: "#eee",
                        }}
                      >
                        {member.name ? member.name.charAt(0) : "?"}
                      </span>
                    )}
                    {member.name}
                  </td>
                  <td>{member.parentDeviceName}</td>
                  <td>
                    {member.isEmailVerified === true ? (
                      <input
                        type="checkbox"
                        checked={selectedFamilyMembers.includes(member.id)}
                        onChange={() => onFamilyMemberSelect(member.id)}
                      />
                    ) : (
                      <span className="text-muted">No email address</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  {filterMessage || "No family members available"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      {/* Pagination - Only show if there are items */}
      {familyMembers.length > itemsPerPage && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end',
          marginTop: '10px',
          paddingRight: '10px',
        }}>
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={3}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            innerClass="pagination pagination-sm mb-0"
          />
        </div>
      )}
    </div>
  );
};

export default PaginatedFamilyMembersTable;